import { TableCell, TableCellProps, useTheme } from "@mui/material";

type XStickyColumnCellProps = TableCellProps & {
  left: string;
};
export const XStickyColumnCell = ({
  left,
  ...props
}: XStickyColumnCellProps) => {
  const theme = useTheme();
  return (
    <TableCell
      {...props}
      sx={{
        ...props.sx,
        position: `sticky`,
        left: left,
        zIndex: "99 !important",
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      {props.children}
    </TableCell>
  );
};
